/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetRewardsCatalogResult } from '../../models/get-rewards-catalog-result';

export interface GetRewardsCatalog$Params {
  SiteName?: string;
}

export function getRewardsCatalog(
  http: HttpClient,
  rootUrl: string,
  params?: GetRewardsCatalog$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<GetRewardsCatalogResult>> {
  const rb = new RequestBuilder(rootUrl, getRewardsCatalog.PATH, 'get');
  if (params) {
    rb.query('SiteName', params.SiteName, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetRewardsCatalogResult>;
    }),
  );
}

getRewardsCatalog.PATH = '/Loyalty/rewards-catalog';
